module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/430.900a8764.png";